export function zordDbDatetimeToStr(dateTime: string | null): string {
    if (!dateTime) return ''

    try {
        // converte "2025-01-30 14:23:10+00" -> ISO válido
        const iso = dateTime.replace(' ', 'T')
        const date = new Date(iso)

        if (Number.isNaN(date.getTime())) return dateTime

        const pad = (n: number) => String(n).padStart(2, '0')

        const day = pad(date.getDate())
        const month = pad(date.getMonth() + 1)
        const year = date.getFullYear()

        const hours = pad(date.getHours())
        const minutes = pad(date.getMinutes())
        const seconds = pad(date.getSeconds())

        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`
    } catch (e) {
        console.error('Erro ao converter data:', dateTime, e)
        return dateTime
    }
}